import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { AuthService } from '../../../services/auth.service';
import { ModalPasswordConfirmationComponent } from '../modal-password-confirmation/modal-password-confirmation.component';

@Component({
  selector: 'app-modal-reset-password',
  templateUrl: './modal-reset-password.component.html',
  styleUrls: ['./modal-reset-password.component.scss']
})
export class ModalResetPasswordComponent implements OnInit {
  email: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalResetPasswordComponent>,
    public dialog: MatDialog,
    public auth: AuthService
  ) {}

  ngOnInit() {
    this.email = '';
  }

  resetPassword() {
    this.auth.resetPassword(this.email).subscribe(res => {});
    this.openPasswordConfirmationDialog();
  }

  openPasswordConfirmationDialog() {
    const passwordConfirmationDialog = this.dialog.open(ModalPasswordConfirmationComponent, {
      width: '400px',
      height: '370px',
      data: { email: this.email }
    });

    passwordConfirmationDialog.afterClosed().subscribe(result => {
      // console.log('Password Confirmation dialog was closed');
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-reset-password/modal-reset-password.component.ts